import PrincipalEditorMainSetting from './principal-editor-mainsetting';

export default PrincipalEditorMainSetting;